import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import { Link } from "gatsby"
import Typography from "@material-ui/core/Typography"
import HomeIcon from '@material-ui/icons/Home'
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  link: {
    marginLeft: theme.spacing(2),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  left: {
    flexGrow: 1,
  },
  title: {
    border: "1px solid #ffffffd0",
    width: "13.2rem",
    textAlign: "center",
    verticalAlign: "middle",
    height: 38,
    paddingTop: 4,
    borderRadius: 22,
    boxShadow: "2px 0px 4px #ffffff60 ",
  },
}))


export default function MyAppBar() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <AppBar position="static" elevation={2}>
        <Toolbar>
          <div className={classes.left}>
            <Typography variant="h5" className={classes.title}>
              <Link to="/">Fiammengo SRL</Link>
            </Typography>
          </div>
          <Link className={classes.link} to="/">
            <HomeIcon />
          </Link>
          <Link className={classes.link} to="/">
            PRODUCTOS
          </Link>
          <Link className={classes.link} to="/blog/">
            BLOG
          </Link>
          <Link className={classes.link} to="/contacto/">
            CONTACTO
          </Link>
        </Toolbar>
      </AppBar>
    </div>
  )
}
